import React, { useEffect } from 'react';
import { useFocusPoint } from '../hooks/useFocusPoint';
import { FloatingPopUp } from '../helpers/FloatingPopUp';
import { useSelector } from 'react-redux';
import { selectAllPoints } from '../map/slice/mapSelectors';
import { CapacityComponentHistory } from '../flows/CapacityComponentHistory';
import { ReusableModal } from '../modals/ReusableModal';
import { PriceComponentHistory } from '../priceComponents/PriceComponentHistory';

export type PointContextMenuProps = {
  pointId: number | null;
  position: { x: number; y: number } | null;
  onClose?: () => void;
};

export const PointContextMenu: React.FC<PointContextMenuProps> = (props) => {
  const points = useSelector(selectAllPoints);
  const popupRef = React.useRef<HTMLDivElement>(null);
  const focusPoint = useFocusPoint();
  const [showFlowHistory, setShowFlowHistory] = React.useState(false);
  const [showPriceHistory, setShowPriceHistory] = React.useState(false);

  const visible = !!props.pointId;
  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      if (props.onClose) {
        props.onClose();
      }
    }
  };
  useEffect(() => {
    if (visible) {
      window.addEventListener('click', handleClickOutside);
    }
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [visible]);

  const point = points[props.pointId ?? ''];
  const hasCapacityComponent = point?.capacity_components?.length > 0;
  const hasPriceComponent = point?.price_components?.length > 0;

  return (
    <>
      <FloatingPopUp visible={visible} position={props.position}>
        <div ref={popupRef} className="bg-light rounded list-group">
          <div
            className="list-group-item list-group-item-action"
            role="button"
            onClick={() => {
              if (props.pointId) focusPoint(props.pointId);
            }}
          >
            Locate
          </div>
          <div
            className={`list-group-item list-group-item-action ${
              hasCapacityComponent ? '' : 'disabled'
            }`}
            role="button"
            onClick={() => {
              setShowFlowHistory(true);
            }}
          >
            Flow history
          </div>
          <div
            className={`list-group-item list-group-item-action ${
              hasPriceComponent ? '' : 'disabled'
            }`}
            role="button"
            onClick={() => {
              setShowPriceHistory(true);
            }}
          >
            Price history
          </div>
        </div>
      </FloatingPopUp>
      {showFlowHistory && hasCapacityComponent && (
        <ReusableModal
          size="xl"
          onClose={() => {
            setShowFlowHistory(false);
          }}
          isOpen={showFlowHistory}
        >
          <CapacityComponentHistory
          // TODO: make this work, use default slice key? Return all slices?
            componentId={point?.capacity_components[0]?.id}
          />
        </ReusableModal>
      )}
      {showPriceHistory && hasPriceComponent && (
        <PriceComponentHistory
          componentId={point?.price_components[0].id}
          setComponentId={() => setShowPriceHistory(false)}
        />
      )}
    </>
  );
};
